import tmhRequest from '@/config/tmhRequest'

export default {

    searchListOutServiceClassify: function (data) {
        return tmhRequest({
            url: '/project/outservicelassify/searchlistoutservicelassify',
            method: 'post',
            params: data,
        })
    },

}


// WEBPACK FOOTER //
// ./src/api/tmh/item/outserviceclassify.js